import { useState, useEffect } from "react";
import axios from "axios";
import { API } from "../../utils/helpers";
import { styles, OZEL_PRODUCTS } from "./adminStyles";
import MaliyetKaynagiSelector from "./MaliyetKaynagiSelector";
import OzanMarjInputs from "./OzanMarjInputs";
import TlIscilikInputs from "./TlIscilikInputs";
import HasInputs from "./HasInputs";
import OzelInputs from "./OzelInputs";

const MarjTab = ({ profile, users, currentUserName, forcedView, isDesktop, onActivate }) => {
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [pricingMode, setPricingMode] = useState(forcedView || "ozan_marj");
  const [pricingModeActive, setPricingModeActive] = useState("ozan_marj");
  const [activeMode, setActiveMode] = useState("mod1");
  const [editingMode, setEditingMode] = useState("mod1");
  const [modes, setModes] = useState([]);
  const [renamingMode, setRenamingMode] = useState(null);
  const [renameValue, setRenameValue] = useState("");
  const [marj, setMarj] = useState({
    gram_1_alis: 2, gram_1_satis: 10, gram_5_10_20_alis: 0, gram_5_10_20_satis: 5,
    ceyrek_alis: 2, ceyrek_satis: 10, yarim_alis: 2, yarim_satis: 0,
    teklik_alis: 2, teklik_satis: 0, ata_alis: 2, ata_satis: 0,
    gremse_alis: -200, gremse_satis: 700, has_alis: -2, has_satis: 2, bilezik_carpan: 0.912
  });
  const [pricesFrozen, setPricesFrozen] = useState(false);
  const [roundingEnabled, setRoundingEnabled] = useState(true);
  const [priceSource, setPriceSource] = useState(null);
  const [applyMarj, setApplyMarj] = useState(true);
  const [marjProducts, setMarjProducts] = useState({
    gram_1: true, gram_5_10_20: true, ceyrek: true, yarim: true,
    teklik: true, ata_lira: true, gremse: true, has_altin: true, bilezik: true,
  });
  const [tlSettings, setTlSettings] = useState({
    has_alis: -2, has_satis: 2, gram_1_alis: 2, gram_1_satis: 10,
    gram_5_10_20_satis: 5, bilezik_carpan: 0.912,
    ceyrek_iscilik: 0, ceyrek_satis_marj: 0, ceyrek_alis_iscilik: 0, ceyrek_alis_marj: 0,
    yarim_iscilik: 0, yarim_satis_marj: 0, yarim_alis_iscilik: 0, yarim_alis_marj: 0,
    teklik_iscilik: 0, teklik_satis_marj: 0, teklik_alis_iscilik: 0, teklik_alis_marj: 0,
    ata_iscilik: 0, ata_satis_marj: 0, ata_alis_iscilik: 0, ata_alis_marj: 0,
    gremse_iscilik: 0, gremse_satis_marj: 0, gremse_alis_iscilik: 0, gremse_alis_marj: 0,
  });
  const [hasSettings, setHasSettings] = useState({
    has_alis: -2, has_satis: 2, bilezik_carpan: 0.912,
    gram_1_satis_has: 0, gram_1_satis_marj: 0, gram_1_alis_has: 0, gram_1_alis_marj: 0,
    gram_separate: false,
    gram_5_10_20_satis_has: 0, gram_5_10_20_satis_marj: 0,
    gram_5_satis_has: 0, gram_5_satis_marj: 0,
    gram_10_satis_has: 0, gram_10_satis_marj: 0,
    gram_20_satis_has: 0, gram_20_satis_marj: 0,
    ceyrek_satis_has: 0, ceyrek_satis_marj: 0, ceyrek_alis_has: 0, ceyrek_alis_marj: 0,
    yarim_satis_has: 0, yarim_satis_marj: 0, yarim_alis_has: 0, yarim_alis_marj: 0,
    teklik_satis_has: 0, teklik_satis_marj: 0, teklik_alis_has: 0, teklik_alis_marj: 0,
    ata_satis_has: 0, ata_satis_marj: 0, ata_alis_has: 0, ata_alis_marj: 0,
    gremse_satis_has: 0, gremse_satis_marj: 0, gremse_alis_has: 0, gremse_alis_marj: 0,
  });
  const [ozelConfig, setOzelConfig] = useState(() => {
    const init = { bilezik_carpan: 0.912, bilezik_milyem: 0.912, bilezik_alis_marj: 0, bilezik_calc_mode: 'milyem' };
    OZEL_PRODUCTS.forEach(p => {
      if (p.type !== 'bilezik') {
        init[`${p.key}_mode`] = "ozan_marj";
        init[`${p.key}_alis_marj`] = 0;
        init[`${p.key}_satis_marj`] = 0;
        init[`${p.key}_alis_val`] = 0;
        init[`${p.key}_satis_val`] = 0;
        init[`${p.key}_alis_iscilik`] = 0;
        init[`${p.key}_satis_iscilik`] = 0;
      }
    });
    return init;
  });

  const getModeName = (modeId) => {
    const found = modes.find(m => m.id === modeId);
    return found ? found.name : modeId;
  };

  const loadMarj = async (mode) => {
    try {
      const res = await axios.get(`${API}/admin/marj?profile=${profile}&mode=${mode}`);
      const defaultMarj = {
        gram_1_alis: 2, gram_1_satis: 10, gram_5_10_20_alis: 0, gram_5_10_20_satis: 5,
        ceyrek_alis: 2, ceyrek_satis: 10, yarim_alis: 2, yarim_satis: 0,
        teklik_alis: 2, teklik_satis: 0, ata_alis: 2, ata_satis: 0,
        gremse_alis: -200, gremse_satis: 700, has_alis: -2, has_satis: 2, bilezik_carpan: 0.912
      };
      setMarj({ ...defaultMarj, ...res.data });
      try {
        const frozenRes = await axios.get(`${API}/admin/frozen-status?profile=${profile}`);
        setPricesFrozen(frozenRes.data.frozen || false);
      } catch { setPricesFrozen(false); }
      try {
        const roundingRes = await axios.get(`${API}/admin/rounding-status?profile=${profile}`);
        setRoundingEnabled(roundingRes.data.rounding_enabled !== false);
      } catch { setRoundingEnabled(true); }
    } catch (e) { console.error(e); }
  };

  const loadModes = async (forPricingMode) => {
    try {
      const pm = forPricingMode || pricingMode || 'ozan_marj';
      const res = await axios.get(`${API}/admin/modes?profile=${profile}&pricing_mode=${pm}`);
      const loadedModes = res.data.modes || [];
      setModes(loadedModes);
      const activeRes = await axios.get(`${API}/admin/active-mode?profile=${profile}&pricing_mode=${pm}`);
      const mode = activeRes.data.mode || (loadedModes[0]?.id || "mod1");
      setActiveMode(mode);
      setEditingMode(mode);
      loadMarj(mode);
      loadPricingMode(mode);
    } catch {
      setModes([{id: "mod1", name: "Mod 1"}, {id: "mod2", name: "Mod 2"}, {id: "pazar", name: "Pazar Gunu"}]);
      loadMarj("mod1");
    }
  };

  const loadPricingMode = async (marjMode, isInitialLoad = false) => {
    try {
      const modeParam = marjMode || editingMode || 'mod1';
      const res = await axios.get(`${API}/admin/pricing-mode?profile=${profile}&marj_mode=${modeParam}`);
      // Only set active indicator on initial load; pricingMode is driven by forcedView
      if (isInitialLoad) {
        setPricingModeActive(res.data.active_mode || "ozan_marj");
      }

      // TL Iscilik - reset then apply
      const defaultTl = { has_alis: -2, has_satis: 2, gram_1_alis: 0, gram_1_satis: 0, gram_5_10_20_satis: 0, bilezik_carpan: 0.912,
        ceyrek_iscilik: 0, ceyrek_satis_marj: 0, ceyrek_alis_iscilik: 0, ceyrek_alis_marj: 0,
        yarim_iscilik: 0, yarim_satis_marj: 0, yarim_alis_iscilik: 0, yarim_alis_marj: 0,
        teklik_iscilik: 0, teklik_satis_marj: 0, teklik_alis_iscilik: 0, teklik_alis_marj: 0,
        ata_lira_iscilik: 0, ata_lira_satis_marj: 0, ata_lira_alis_iscilik: 0, ata_lira_alis_marj: 0,
        gremse_iscilik: 0, gremse_satis_marj: 0, gremse_alis_iscilik: 0, gremse_alis_marj: 0 };
      if (res.data.tl_iscilik && Object.keys(res.data.tl_iscilik).length > 0) {
        setTlSettings({ ...defaultTl, ...res.data.tl_iscilik });
      } else {
        setTlSettings(defaultTl);
      }

      // HAS - reset then apply
      const defaultHas = { has_alis: -2, has_satis: 2, bilezik_carpan: 0.912, gram_separate: false,
        gram_1_satis_has: 0, gram_1_satis_marj: 0, gram_1_alis_has: 0, gram_1_alis_marj: 0,
        gram_5_10_20_satis_has: 0, gram_5_10_20_satis_marj: 0,
        gram_5_satis_has: 0, gram_5_satis_marj: 0, gram_10_satis_has: 0, gram_10_satis_marj: 0, gram_20_satis_has: 0, gram_20_satis_marj: 0,
        ceyrek_satis_has: 0, ceyrek_satis_marj: 0, ceyrek_alis_has: 0, ceyrek_alis_marj: 0,
        yarim_satis_has: 0, yarim_satis_marj: 0, yarim_alis_has: 0, yarim_alis_marj: 0,
        teklik_satis_has: 0, teklik_satis_marj: 0, teklik_alis_has: 0, teklik_alis_marj: 0,
        ata_lira_satis_has: 0, ata_lira_satis_marj: 0, ata_lira_alis_has: 0, ata_lira_alis_marj: 0,
        gremse_satis_has: 0, gremse_satis_marj: 0, gremse_alis_has: 0, gremse_alis_marj: 0 };
      if (res.data.has && Object.keys(res.data.has).length > 0) {
        setHasSettings({ ...defaultHas, ...res.data.has });
      } else {
        setHasSettings(defaultHas);
      }

      // Ozel - reset then apply
      const defaultOzel = { bilezik_carpan: 0.912, bilezik_milyem: 0.912, bilezik_alis_marj: 0, bilezik_calc_mode: 'milyem' };
      OZEL_PRODUCTS.forEach(p => {
        if (p.type !== 'bilezik') {
          defaultOzel[`${p.key}_mode`] = "ozan_marj";
          defaultOzel[`${p.key}_alis_marj`] = 0; defaultOzel[`${p.key}_satis_marj`] = 0;
          defaultOzel[`${p.key}_alis_val`] = 0; defaultOzel[`${p.key}_satis_val`] = 0;
          defaultOzel[`${p.key}_alis_iscilik`] = 0; defaultOzel[`${p.key}_satis_iscilik`] = 0;
        }
      });
      if (res.data.ozel && Object.keys(res.data.ozel).length > 0) {
        setOzelConfig({ ...defaultOzel, ...res.data.ozel });
      } else {
        setOzelConfig(defaultOzel);
      }
    } catch (e) { console.error(e); }
  };

  const loadPriceSource = async () => {
    try {
      const res = await axios.get(`${API}/admin/price-source?profile=${profile}`);
      setPriceSource(res.data.active ? res.data.source_profile : null);
      setApplyMarj(res.data.apply_marj !== false);
      // Load marj products
      const mp = await axios.get(`${API}/admin/price-source/marj-products?profile=${profile}`);
      if (mp.data.marj_products && Object.keys(mp.data.marj_products).length > 0) {
        setMarjProducts(prev => ({ ...prev, ...mp.data.marj_products }));
      }
    } catch (e) { console.error(e); }
  };

  useEffect(() => {
    loadPricingMode(null, true);
    loadPriceSource();
  }, [profile]); // eslint-disable-line react-hooks/exhaustive-deps

  // Reload modes when pricingMode changes
  useEffect(() => {
    if (pricingMode) {
      loadModes(pricingMode);
    }
  }, [pricingMode, profile]); // eslint-disable-line react-hooks/exhaustive-deps

  // Sync forcedView from bottom nav to internal pricingMode
  useEffect(() => {
    if (forcedView && ['ozan_marj', 'tl_iscilik', 'has', 'ozel'].includes(forcedView)) {
      setPricingMode(forcedView);
    }
  }, [forcedView]);

  const handleChange = (key, value) => setMarj(prev => ({ ...prev, [key]: value }));
  const handleTlChange = (key, value) => setTlSettings(prev => ({ ...prev, [key]: value }));
  const handleHasChange = (key, value) => setHasSettings(prev => ({ ...prev, [key]: value }));

  const handleSave = async () => {
    try {
      const numericMarj = {};
      for (const [k, v] of Object.entries(marj)) {
        const cleaned = String(v).replace(',', '.');
        numericMarj[k] = cleaned === '' || cleaned === '-' ? 0 : parseFloat(cleaned) || 0;
      }
      await axios.post(`${API}/admin/marj?profile=${profile}&mode=${editingMode}`, numericMarj);
      setSuccess(`${getModeName(editingMode)} marjlari kaydedildi!`);
      setTimeout(() => setSuccess(""), 3000);
    } catch { setError("Kaydetme hatasi!"); setTimeout(() => setError(""), 3000); }
  };

  const handleModeChange = (mode) => { setEditingMode(mode); loadMarj(mode); loadPricingMode(mode); };

  const addMode = async () => {
    const newId = `mod_${Date.now()}`;
    const newMode = { id: newId, name: `Mod ${modes.length + 1}` };
    const updated = [...modes, newMode];
    setModes(updated);
    try {
      await axios.post(`${API}/admin/modes?profile=${profile}&pricing_mode=${pricingMode}`, { modes: updated });
      setSuccess(`"${newMode.name}" eklendi`); setTimeout(() => setSuccess(""), 3000);
    } catch { setError("Mod eklenemedi!"); setTimeout(() => setError(""), 3000); }
  };

  const startRename = (mode) => { setRenamingMode(mode.id); setRenameValue(mode.name); };

  const saveRename = async (modeId) => {
    if (!renameValue.trim()) return;
    const updated = modes.map(m => m.id === modeId ? { ...m, name: renameValue.trim() } : m);
    setModes(updated); setRenamingMode(null);
    try {
      await axios.post(`${API}/admin/modes?profile=${profile}&pricing_mode=${pricingMode}`, { modes: updated });
      setSuccess("Mod ismi degistirildi"); setTimeout(() => setSuccess(""), 3000);
    } catch { setError("Isim degistirilemedi!"); setTimeout(() => setError(""), 3000); }
  };

  const deleteMode = async (modeId) => {
    if (modes.length <= 1) { setError("En az 1 mod olmali!"); setTimeout(() => setError(""), 3000); return; }
    if (!window.confirm(`"${getModeName(modeId)}" modunu silmek istediginize emin misiniz?`)) return;
    const updated = modes.filter(m => m.id !== modeId);
    setModes(updated);
    try {
      await axios.delete(`${API}/admin/modes/${modeId}?profile=${profile}&pricing_mode=${pricingMode}`);
      if (activeMode === modeId) {
        const newActive = updated[0]?.id || "mod1";
        await axios.post(`${API}/admin/active-mode?profile=${profile}&pricing_mode=${pricingMode}`, { mode: newActive });
        setActiveMode(newActive);
      }
      if (editingMode === modeId) { setEditingMode(updated[0]?.id || "mod1"); loadMarj(updated[0]?.id || "mod1"); }
      setSuccess("Mod silindi"); setTimeout(() => setSuccess(""), 3000);
    } catch { setError("Mod silinemedi!"); setTimeout(() => setError(""), 3000); }
  };

  const saveActiveMode = async (mode) => {
    try {
      await axios.post(`${API}/admin/active-mode?profile=${profile}&pricing_mode=${pricingMode}`, { mode });
      setActiveMode(mode);
      setSuccess(`Aktif mod: ${getModeName(mode)}`); setTimeout(() => setSuccess(""), 3000);
    } catch { setError("Mod degistirilemedi!"); setTimeout(() => setError(""), 3000); }
  };

  const savePricingModeSettings = async () => {
    try {
      let settings;
      if (pricingMode === "tl_iscilik") settings = { ...tlSettings };
      else if (pricingMode === "has") settings = { ...hasSettings };
      else if (pricingMode === "ozel") settings = { ...ozelConfig };
      else settings = {};
      for (const [k, v] of Object.entries(settings)) {
        // _mode ve _calc_mode alanlari her zaman string olmali (DB'de 0 olarak saklananlari da duzelt)
        if (k.endsWith('_mode') || k.endsWith('_calc_mode')) {
          if (typeof v !== 'string' || !v) {
            settings[k] = k.endsWith('_calc_mode') ? 'milyem' : 'ozan_marj';
          }
          continue;
        }
        if (typeof v === 'string') {
          const cleaned = String(v).replace(',', '.');
          if (cleaned === '' || cleaned === '-') {
            settings[k] = 0;
          } else {
            const num = parseFloat(cleaned);
            // Sayisal degil ise (mode/string config gibi) string olarak birak
            settings[k] = isNaN(num) ? v : num;
          }
        }
      }
      await axios.post(`${API}/admin/pricing-mode/save?profile=${profile}`, { mode: pricingMode, settings, marj_mode: editingMode });
      const modeNames = { ozan_marj: 'Ozan+Marj', tl_iscilik: 'TL Iscilik', has: 'HAS', ozel: 'Ozel' };
      setSuccess(`${modeNames[pricingMode] || pricingMode} ayarlari kaydedildi!`);
      setTimeout(() => setSuccess(""), 3000);
    } catch { setError("Kaydetme hatasi!"); setTimeout(() => setError(""), 3000); }
  };

  const activatePricingMode = async () => {
    try {
      const settings = pricingMode === "tl_iscilik" ? { ...tlSettings } : pricingMode === "has" ? { ...hasSettings } : pricingMode === "ozel" ? { ...ozelConfig } : null;
      if (settings) {
        for (const [k, v] of Object.entries(settings)) {
          if (typeof v === 'string') {
            const cleaned = String(v).replace(',', '.');
            const num = parseFloat(cleaned);
            // Keep string if it's a mode selector or non-numeric value
            settings[k] = cleaned === '' || cleaned === '-' ? 0 : isNaN(num) ? v : num;
          }
        }
      }
      await axios.post(`${API}/admin/pricing-mode/activate?profile=${profile}`, { mode: pricingMode, settings });
      setPricingModeActive(pricingMode);
      if (onActivate) onActivate(pricingMode);
      const modeNames = { ozan_marj: "Ozan+Marj", tl_iscilik: "TL Iscilik", has: "HAS", ozel: "Ozel" };
      setSuccess(`${modeNames[pricingMode]} modu aktif edildi!`);
      setTimeout(() => setSuccess(""), 3000);
    } catch { setError("Aktif etme hatasi!"); setTimeout(() => setError(""), 3000); }
  };

  const handleToggleFreeze = async () => {
    try {
      const newFrozenState = !pricesFrozen;
      await axios.post(`${API}/admin/freeze-prices?profile=${profile}`, { frozen: newFrozenState });
      setPricesFrozen(newFrozenState);
      setSuccess(newFrozenState ? "Fiyatlar sabitlendi!" : "Fiyat guncelleme devam ediyor!");
      setTimeout(() => setSuccess(""), 3000);
    } catch { setError("Fiyat sabitleme hatasi!"); setTimeout(() => setError(""), 3000); }
  };

  const handleToggleRounding = async () => {
    try {
      const res = await axios.post(`${API}/admin/toggle-rounding?profile=${profile}`);
      setRoundingEnabled(res.data.rounding_enabled);
      setSuccess(res.data.rounding_enabled ? "Yuvarlamaya devam ediliyor!" : "Yuvarlama durduruldu!");
      setTimeout(() => setSuccess(""), 3000);
    } catch { setError("Yuvarlama ayari degistirilemedi!"); setTimeout(() => setError(""), 3000); }
  };

  const setPriceSourceProfile = async (sourceProfile) => {
    try {
      await axios.post(`${API}/admin/price-source?profile=${profile}`, { source_profile: sourceProfile });
      setPriceSource(sourceProfile);
      const profileLabels = { "default": "Ana Sayfa", "1": "UFUKTEPE", "2": "DUTLUK" };
      setSuccess(`Fiyat kaynagi: ${profileLabels[sourceProfile] || sourceProfile}`);
      setTimeout(() => setSuccess(""), 3000);
    } catch { setError("Fiyat kaynagi ayarlanamadi!"); setTimeout(() => setError(""), 3000); }
  };

  const clearPriceSource = async () => {
    try {
      await axios.post(`${API}/admin/price-source?profile=${profile}`, { source_profile: null });
      setPriceSource(null);
      setApplyMarj(true);
      setSuccess("Fiyat kaynagi iptal edildi - kendi marjlari kullaniliyor");
      setTimeout(() => setSuccess(""), 3000);
    } catch { setError("Iptal edilemedi!"); setTimeout(() => setError(""), 3000); }
  };

  const toggleApplyMarj = async () => {
    try {
      const newVal = !applyMarj;
      await axios.post(`${API}/admin/price-source/toggle-marj?profile=${profile}`, { apply_marj: newVal });
      setApplyMarj(newVal);
      setSuccess(newVal ? "Marj: AKTIF" : "Marj: PASIF (ham fiyatlar)");
      setTimeout(() => setSuccess(""), 3000);
    } catch { setError("Marj ayari degistirilemedi!"); setTimeout(() => setError(""), 3000); }
  };

  const toggleMarjProduct = async (productKey) => {
    const updated = { ...marjProducts, [productKey]: !marjProducts[productKey] };
    setMarjProducts(updated);
    try {
      await axios.post(`${API}/admin/price-source/marj-products?profile=${profile}`, { marj_products: updated });
    } catch (e) { console.error(e); }
  };

  const toggleAllMarjProducts = async () => {
    const allChecked = Object.values(marjProducts).every(v => v);
    const updated = {};
    Object.keys(marjProducts).forEach(k => { updated[k] = !allChecked; });
    setMarjProducts(updated);
    try {
      await axios.post(`${API}/admin/price-source/marj-products?profile=${profile}`, { marj_products: updated });
    } catch (e) { console.error(e); }
  };

  const modeBtnStyle = (isActive, isEditing) => ({
    padding: isEditing ? '12px 30px' : '8px 16px',
    backgroundColor: isActive ? '#DA9F54' : isEditing ? '#2a2a2a' : 'transparent',
    color: isActive ? '#000' : '#DA9F54',
    border: isActive ? '2px solid #DA9F54' : isEditing ? '2px solid #444' : '2px solid #DA9F54',
    borderRadius: isEditing ? '8px' : '5px', cursor: isActive && !isEditing ? 'default' : 'pointer',
    fontWeight: 'bold', fontSize: isEditing ? '15px' : '13px',
    opacity: isActive && !isEditing ? 1 : 0.8, transition: 'all 0.2s'
  });

  const marjVal = (key) => marj[key] === 0 || marj[key] === '0' ? '' : marj[key];
  const otherProfiles = users.filter(u => u.profile !== profile);

  // ── Right sidebar content (desktop only for ozan_marj) ──
  const renderActionsSidebar = () => (
    <div style={{ width: 250, minWidth: 250, display: 'flex', flexDirection: 'column', gap: '12px' }}>
      {/* 1: Kaydet, Sabitle, Yuvarlama */}
      <div style={{ background: '#e4e4e4', borderRadius: '10px', padding: '14px', border: '1px solid #e0e0e0', display: 'flex', flexDirection: 'column', gap: '8px' }}>
        {pricingMode === 'ozan_marj' && (
          <button onClick={handleSave} style={{ ...styles.saveButton, marginTop: 0, fontSize: '14px', padding: '12px' }} data-testid="save-marj-btn">Kaydet</button>
        )}
        {pricingMode === 'tl_iscilik' && (
          <>
            <button onClick={savePricingModeSettings} style={{ ...styles.saveButton, marginTop: 0, fontSize: '14px', padding: '12px' }} data-testid="save-tl-btn">Kaydet</button>
            <button onClick={activatePricingMode} style={{ ...styles.saveButton, backgroundColor: pricingModeActive === 'tl_iscilik' ? '#27ae60' : '#e67e22', marginTop: 0, fontSize: '13px', padding: '10px' }} data-testid="activate-tl-btn">
              {pricingModeActive === 'tl_iscilik' ? '\u2713 TL ISCILIK AKTIF' : 'TL ISCILIK AKTIF ET'}
            </button>
          </>
        )}
        {pricingMode === 'has' && (
          <>
            <button onClick={savePricingModeSettings} style={{ ...styles.saveButton, marginTop: 0, fontSize: '14px', padding: '12px' }} data-testid="save-has-btn">Kaydet</button>
            <button onClick={activatePricingMode} style={{ ...styles.saveButton, backgroundColor: pricingModeActive === 'has' ? '#27ae60' : '#e67e22', marginTop: 0, fontSize: '13px', padding: '10px' }} data-testid="activate-has-btn">
              {pricingModeActive === 'has' ? '\u2713 HAS MODU AKTIF' : 'HAS MODU AKTIF ET'}
            </button>
          </>
        )}
        {pricingMode === 'ozel' && (
          <>
            <button onClick={savePricingModeSettings} style={{ ...styles.saveButton, marginTop: 0, fontSize: '14px', padding: '12px' }} data-testid="save-ozel-btn">Kaydet</button>
            <button onClick={activatePricingMode} style={{ ...styles.saveButton, backgroundColor: pricingModeActive === 'ozel' ? '#27ae60' : '#e67e22', marginTop: 0, fontSize: '13px', padding: '10px' }} data-testid="activate-ozel-btn">
              {pricingModeActive === 'ozel' ? '\u2713 OZEL MOD AKTIF' : 'OZEL MOD AKTIF ET'}
            </button>
          </>
        )}
        {pricingModeActive !== 'ozan_marj' && pricingMode === 'ozan_marj' && (
          <button onClick={() => { setPricingMode('ozan_marj'); activatePricingMode(); }} style={{ ...styles.saveButton, backgroundColor: '#27ae60', marginTop: 0, fontSize: '13px', padding: '10px' }} data-testid="activate-ozan-btn">OZAN+MARJ Aktif Et</button>
        )}
        <button onClick={handleToggleFreeze} style={{ ...styles.freezeButton, backgroundColor: pricesFrozen ? '#e74c3c' : '#27ae60', marginTop: 0, fontSize: '13px', padding: '10px' }} data-testid="freeze-btn">
          {pricesFrozen ? 'Fiyatlari Serbest Birak' : 'Fiyatlari Sabitle'}
        </button>
        <button onClick={handleToggleRounding} style={{ ...styles.freezeButton, backgroundColor: roundingEnabled ? '#3498db' : '#95a5a6', marginTop: 0, fontSize: '13px', padding: '10px' }} data-testid="rounding-btn">
          {roundingEnabled ? 'Yuvarlama: ACIK' : 'Yuvarlama: KAPALI'}
        </button>
      </div>

      {/* 2: Fiyat Kaynagi (Sube secenekleri) */}
      {otherProfiles.length > 0 && (
        <div style={{ background: '#e4e4e4', borderRadius: '10px', padding: '14px', border: '1px solid #e0e0e0' }}>
          <p style={{ fontSize: '13px', fontWeight: 'bold', color: '#09301E', marginBottom: '8px', textAlign: 'center' }}>Fiyat Kaynagi</p>
          {priceSource && priceSource !== 'altinkaynak' && (
            <div style={{ textAlign: 'center', marginBottom: '8px', padding: '6px', backgroundColor: '#DA9F54', borderRadius: '6px' }}>
              <span style={{ color: '#000', fontWeight: 'bold', fontSize: '12px' }}>Aktif: {users.find(u => u.profile === priceSource)?.name || priceSource}</span>
            </div>
          )}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            {otherProfiles.map(p => (
              <button key={p.profile} onClick={() => setPriceSourceProfile(p.profile)} disabled={priceSource === p.profile}
                style={{
                  padding: '8px', fontSize: '12px', fontWeight: 'bold', cursor: priceSource === p.profile ? 'default' : 'pointer',
                  backgroundColor: priceSource === p.profile ? '#DA9F54' : '#09301E', color: priceSource === p.profile ? '#000' : '#fff',
                  border: 'none', borderRadius: '6px', transition: 'all 0.2s', width: '100%',
                }}
                data-testid={`source-${p.profile}-btn`}
              >{p.name}</button>
            ))}
            {priceSource && priceSource !== 'altinkaynak' && (
              <button onClick={clearPriceSource}
                style={{ padding: '8px', fontSize: '11px', fontWeight: 'bold', backgroundColor: '#e74c3c', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer', width: '100%' }}
                data-testid="clear-source-btn"
              >Iptal Et</button>
            )}
          </div>
        </div>
      )}

      {/* 3: Mod Düzenleme - tüm sekmeler */}
      <div style={{ background: '#e4e4e4', borderRadius: '10px', padding: '14px', border: '1px solid #e0e0e0' }}>
          <p style={{ fontSize: '12px', fontWeight: 'bold', color: '#09301E', marginBottom: '8px', textAlign: 'center' }}>Mod Duzenle</p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            {modes.map(m => (
              <div key={m.id} style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                <button onClick={() => handleModeChange(m.id)} style={{
                  flex: 1, padding: '8px 10px', fontSize: '13px', fontWeight: 'bold', borderRadius: '6px', cursor: 'pointer',
                  backgroundColor: editingMode === m.id ? '#2a2a2a' : 'transparent', color: editingMode === m.id ? '#DA9F54' : '#09301E',
                  border: editingMode === m.id ? '2px solid #DA9F54' : '1px solid #ccc', transition: 'all 0.2s', textAlign: 'left',
                }}>{m.name}</button>
                {editingMode === m.id && (
                  <>
                    <button onClick={() => startRename(m)} style={{ background: '#DA9F54', color: '#000', border: 'none', borderRadius: '4px', padding: '6px 8px', cursor: 'pointer', fontSize: '11px', fontWeight: 'bold' }} title="Isim degistir">&#9998;</button>
                    <button onClick={() => deleteMode(m.id)} style={{ background: '#e74c3c', color: '#fff', border: 'none', borderRadius: '4px', padding: '6px 8px', cursor: 'pointer', fontSize: '11px', fontWeight: 'bold' }} title="Sil">&#10005;</button>
                  </>
                )}
              </div>
            ))}
            <button onClick={addMode} style={{ padding: '8px', backgroundColor: '#27ae60', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold', fontSize: '16px' }} data-testid="add-mode-btn" title="Yeni mod ekle">+ Yeni Mod</button>
          </div>
          {renamingMode && (
            <div style={{ marginTop: '10px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
              <input type="text" value={renameValue} onChange={(e) => setRenameValue(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') saveRename(renamingMode); }} style={{ padding: '8px', fontSize: '13px', border: '2px solid #DA9F54', borderRadius: '6px', width: '100%' }} autoFocus data-testid="rename-mode-input" />
              <div style={{ display: 'flex', gap: '6px' }}>
                <button onClick={() => saveRename(renamingMode)} style={{ flex: 1, padding: '8px', backgroundColor: '#DA9F54', color: '#000', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold', fontSize: '12px' }}>Kaydet</button>
                <button onClick={() => setRenamingMode(null)} style={{ flex: 1, padding: '8px', backgroundColor: '#666', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '12px' }}>Iptal</button>
              </div>
            </div>
          )}
        </div>

      <button onClick={() => window.location.href = profile === "default" ? "/" : `/${profile}`} style={{ ...styles.backButton, fontSize: '12px', padding: '10px' }}>Fiyat Sayfasina Don</button>
    </div>
  );

  // ── Ozan+Marj: Marj input fields only ──
  const sectionRow = isDesktop
    ? { ...styles.section, display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }
    : styles.section;
  const sectionH3 = isDesktop
    ? { margin: 0, minWidth: '180px', fontSize: '16px', whiteSpace: 'nowrap', fontWeight: 'bold' }
    : {};

  const showCheckboxes = priceSource === 'altinkaynak' && applyMarj;
  const marjCheckbox = (productKey) => showCheckboxes ? (
    <input type="checkbox" checked={!!marjProducts[productKey]} onChange={() => toggleMarjProduct(productKey)}
      style={{ width: '18px', height: '18px', cursor: 'pointer', accentColor: '#DA9F54', marginLeft: 'auto', flexShrink: 0 }}
      data-testid={`marj-check-${productKey}`} />
  ) : null;

  const renderMaliyetKaynagi = () => (
    <MaliyetKaynagiSelector
      isDesktop={isDesktop}
      priceSource={priceSource}
      applyMarj={applyMarj}
      clearPriceSource={clearPriceSource}
      setPriceSourceProfile={setPriceSourceProfile}
      toggleApplyMarj={toggleApplyMarj}
    />
  );

  const renderOzanMarjInputs = () => (
    <OzanMarjInputs
      isDesktop={isDesktop}
      priceSource={priceSource}
      applyMarj={applyMarj}
      marjProducts={marjProducts}
      marj={marj}
      editingMode={editingMode}
      getModeName={getModeName}
      handleChange={handleChange}
      marjVal={marjVal}
      toggleMarjProduct={toggleMarjProduct}
      toggleAllMarjProducts={toggleAllMarjProducts}
    />
  );

  // ── DESKTOP LAYOUT ──
  if (isDesktop && forcedView) {
    return (
      <div style={{ padding: '20px 24px 30px' }}>
        {success && <p style={styles.success}>{success}</p>}
        {error && <p style={styles.error}>{error}</p>}

        {renderMaliyetKaynagi()}

        {/* Active mode indicator - full width */}
        <div style={{ textAlign: 'center', marginBottom: '15px', padding: '8px', backgroundColor: '#1a3d2e', borderRadius: '8px', border: '1px solid #2a5a40' }}>
          <span style={{ color: '#888', fontSize: '12px' }}>Aktif Mod: </span>
          <span style={{ color: pricingModeActive === pricingMode ? '#22c55e' : '#DA9F54', fontSize: '13px', fontWeight: 'bold' }}>
            {pricingModeActive === 'ozan_marj' ? 'OZAN+MARJ' : pricingModeActive === 'tl_iscilik' ? 'TL ISCILIK' : pricingModeActive === 'ozel' ? 'OZEL' : 'HAS'}
            {pricingModeActive === pricingMode && ' (Bu Mod)'}
          </span>
        </div>

        {/* Aktif Mod selector - only on the active pricing mode's tab */}
        {pricingMode === pricingModeActive && (
          <div style={{ backgroundColor: '#1a3d2e', padding: '12px 20px', borderRadius: '10px', marginBottom: '16px', border: '2px solid #DA9F54' }}>
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '10px'}}>
              <div style={{display: 'flex', gap: '8px', flexWrap: 'wrap'}}>
                {modes.map(m => (
                  <button key={m.id} onClick={() => saveActiveMode(m.id)} disabled={activeMode === m.id} style={modeBtnStyle(activeMode === m.id, false)}>
                    {activeMode === m.id ? '\u2713 ' : ''}{m.name}
                  </button>
                ))}
              </div>
              <span style={{color: '#DA9F54', fontWeight: 'bold', fontSize: '16px'}}>Aktif Mod: {getModeName(activeMode)}</span>
            </div>
          </div>
        )}

        {/* 2-column layout: Left=settings, Right=actions */}
        <div style={{ display: 'flex', gap: '20px', alignItems: 'flex-start' }}>
          {/* LEFT: Main settings panel */}
          <div style={{ flex: 1, background: '#e4e4e4', padding: '24px', borderRadius: '12px' }}>
            {pricingMode === 'ozan_marj' && renderOzanMarjInputs()}

            {pricingMode === 'tl_iscilik' && (
              <TlIscilikInputs
                isDesktop={isDesktop}
                priceSource={priceSource}
                tlSettings={tlSettings}
                handleTlChange={handleTlChange}
              />
            )}

            {pricingMode === 'has' && (
              <HasInputs
                isDesktop={isDesktop}
                priceSource={priceSource}
                hasSettings={hasSettings}
                handleHasChange={handleHasChange}
              />
            )}

            {pricingMode === 'ozel' && (
              <OzelInputs
                priceSource={priceSource}
                ozelConfig={ozelConfig}
                setOzelConfig={setOzelConfig}
              />
            )}
          </div>

          {/* RIGHT: Actions sidebar */}
          {renderActionsSidebar()}
        </div>
      </div>
    );
  }

  // ── MOBILE LAYOUT (single column) ──
  return (
    <div style={{display: 'flex', justifyContent: 'center', padding: '20px 20px 30px'}}>
      <div style={styles.panel}>
        {success && <p style={styles.success}>{success}</p>}
        {error && <p style={styles.error}>{error}</p>}

        {renderMaliyetKaynagi()}

        {/* Fiyatlandirma Modu Secici - Only show when no forcedView */}
        {!forcedView && (
          <div style={{ backgroundColor: '#1a3d2e', padding: '15px 20px', borderRadius: '10px', marginBottom: '20px', border: '2px solid #DA9F54' }}>
            <p style={{ color: '#ccc', fontSize: '13px', marginBottom: '10px', textAlign: 'center' }}>Fiyatlandirma Modu</p>
            <div style={{ display: 'flex', gap: '8px', justifyContent: 'center', flexWrap: 'wrap' }}>
              {[
                { id: 'ozan_marj', name: 'OZAN+MARJ' },
                { id: 'tl_iscilik', name: 'TL ISCILIK' },
                { id: 'has', name: 'HAS' },
                { id: 'ozel', name: 'OZEL' }
              ].map(m => (
                <button key={m.id} onClick={() => setPricingMode(m.id)} data-testid={`pricing-mode-${m.id}-btn`}
                  style={{
                    padding: '10px 20px', fontSize: '14px', fontWeight: 'bold', borderRadius: '8px', cursor: 'pointer', transition: 'all 0.2s',
                    backgroundColor: pricingMode === m.id ? '#DA9F54' : '#09301E', color: pricingMode === m.id ? '#000' : '#fff',
                    border: pricingMode === m.id ? '2px solid #b8860b' : '2px solid #09301E',
                  }}>
                  {pricingModeActive === m.id ? '\u2713 ' : ''}{m.name}
                </button>
              ))}
            </div>
            <p style={{ color: '#DA9F54', fontSize: '12px', textAlign: 'center', marginTop: '8px' }}>
              Aktif: {pricingModeActive === 'ozan_marj' ? 'OZAN+MARJ' : pricingModeActive === 'tl_iscilik' ? 'TL ISCILIK' : pricingModeActive === 'ozel' ? 'OZEL' : 'HAS'}
            </p>
          </div>
        )}

        {/* Active mode indicator mobile */}
        {forcedView && (
          <div style={{ textAlign: 'center', marginBottom: '15px', padding: '8px', backgroundColor: '#1a3d2e', borderRadius: '8px', border: '1px solid #2a5a40' }}>
            <span style={{ color: '#888', fontSize: '12px' }}>Aktif Mod: </span>
            <span style={{ color: pricingModeActive === pricingMode ? '#22c55e' : '#DA9F54', fontSize: '13px', fontWeight: 'bold' }}>
              {pricingModeActive === 'ozan_marj' ? 'OZAN+MARJ' : pricingModeActive === 'tl_iscilik' ? 'TL ISCILIK' : pricingModeActive === 'ozel' ? 'OZEL' : 'HAS'}
              {pricingModeActive === pricingMode && ' (Bu Mod)'}
            </span>
          </div>
        )}

        {/* Aktif Mod Seçici - sadece aktif fiyatlama modunun sekmesinde */}
        {pricingMode === pricingModeActive && (
          <div style={{ backgroundColor: '#1a3d2e', padding: '15px 20px', borderRadius: '10px', marginBottom: '20px', border: '2px solid #DA9F54' }}>
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '10px'}}>
              <span style={{color: '#DA9F54', fontWeight: 'bold', fontSize: '16px'}}>Aktif Mod: {getModeName(activeMode)}</span>
              <div style={{display: 'flex', gap: '8px', flexWrap: 'wrap'}}>
                {modes.map(m => (
                  <button key={m.id} onClick={() => saveActiveMode(m.id)} disabled={activeMode === m.id} style={modeBtnStyle(activeMode === m.id, false)}>
                    {activeMode === m.id ? '\u2713 ' : ''}{m.name}
                  </button>
                ))}
              </div>
            </div>
          </div>
        )}
        <div style={{ display: 'flex', gap: '10px', marginBottom: '15px', justifyContent: 'center', flexWrap: 'wrap', alignItems: 'center' }}>
          {modes.map(m => (
            <div key={m.id} style={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}>
              <button onClick={() => handleModeChange(m.id)} style={modeBtnStyle(editingMode === m.id, true)}>{m.name}</button>
              {editingMode === m.id && (
                <div style={{ display: 'flex', gap: '4px', marginLeft: '4px' }}>
                  <button onClick={() => startRename(m)} style={{ background: '#DA9F54', color: '#000', border: 'none', borderRadius: '4px', padding: '4px 8px', cursor: 'pointer', fontSize: '12px', fontWeight: 'bold' }} title="Isim degistir">&#9998;</button>
                  <button onClick={() => deleteMode(m.id)} style={{ background: '#e74c3c', color: '#fff', border: 'none', borderRadius: '4px', padding: '4px 8px', cursor: 'pointer', fontSize: '12px', fontWeight: 'bold' }} title="Sil">&#10005;</button>
                </div>
              )}
            </div>
          ))}
          <button onClick={addMode} style={{ padding: '12px 20px', backgroundColor: '#27ae60', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold', fontSize: '18px' }} data-testid="add-mode-btn-mobile" title="Yeni mod ekle">+</button>
        </div>
        {renamingMode && (
          <div style={{ display: 'flex', gap: '8px', justifyContent: 'center', marginBottom: '20px', alignItems: 'center' }}>
            <input type="text" value={renameValue} onChange={(e) => setRenameValue(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') saveRename(renamingMode); }} style={{ padding: '8px 12px', fontSize: '16px', border: '2px solid #DA9F54', borderRadius: '8px', width: '180px' }} autoFocus data-testid="rename-mode-input" />
            <button onClick={() => saveRename(renamingMode)} style={{ padding: '8px 16px', backgroundColor: '#DA9F54', color: '#000', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold' }}>Kaydet</button>
            <button onClick={() => setRenamingMode(null)} style={{ padding: '8px 16px', backgroundColor: '#666', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer' }}>Iptal</button>
          </div>
        )}

        {/* OZAN+MARJ MODU mobile */}
        {pricingMode === 'ozan_marj' && (
          <>
            {renderOzanMarjInputs()}
            <button onClick={handleSave} style={styles.saveButton} data-testid="save-marj-btn">Kaydet</button>
            {pricingModeActive !== 'ozan_marj' && (
              <button onClick={() => { setPricingMode('ozan_marj'); activatePricingMode(); }} style={{ ...styles.saveButton, backgroundColor: '#27ae60', marginTop: '10px' }} data-testid="activate-ozan-btn">OZAN+MARJ Aktif Et</button>
            )}
          </>
        )}

        {/* TL ISCILIK mobile */}
        {pricingMode === 'tl_iscilik' && (
          <>
            <TlIscilikInputs
              isDesktop={false}
              priceSource={priceSource}
              tlSettings={tlSettings}
              handleTlChange={handleTlChange}
            />
            <button onClick={savePricingModeSettings} style={styles.saveButton} data-testid="save-tl-btn">Kaydet</button>
            <button onClick={activatePricingMode} style={{ ...styles.saveButton, backgroundColor: pricingModeActive === 'tl_iscilik' ? '#27ae60' : '#e67e22', marginTop: '10px' }} data-testid="activate-tl-btn">
              {pricingModeActive === 'tl_iscilik' ? '\u2713 TL ISCILIK AKTIF' : 'TL ISCILIK AKTIF ET'}
            </button>
          </>
        )}

        {/* HAS mobile */}
        {pricingMode === 'has' && (
          <>
            <HasInputs
              isDesktop={false}
              priceSource={priceSource}
              hasSettings={hasSettings}
              handleHasChange={handleHasChange}
            />
            <button onClick={savePricingModeSettings} style={styles.saveButton} data-testid="save-has-btn">Kaydet</button>
            <button onClick={activatePricingMode} style={{ ...styles.saveButton, backgroundColor: pricingModeActive === 'has' ? '#27ae60' : '#e67e22', marginTop: '10px' }} data-testid="activate-has-btn">
              {pricingModeActive === 'has' ? '\u2713 HAS MODU AKTIF' : 'HAS MODU AKTIF ET'}
            </button>
          </>
        )}

        {/* OZEL mobile */}
        {pricingMode === 'ozel' && (
          <>
            <div style={{ backgroundColor: '#f9f5ef', padding: '15px', borderRadius: '10px', marginBottom: '15px', border: '2px solid #DA9F54' }}>
              <OzelInputs
                isDesktop={false}
                priceSource={priceSource}
                ozelConfig={ozelConfig}
                setOzelConfig={setOzelConfig}
              />
            </div>
            <button onClick={savePricingModeSettings} style={styles.saveButton} data-testid="save-ozel-btn">Kaydet</button>
            <button onClick={activatePricingMode} style={{ ...styles.saveButton, backgroundColor: pricingModeActive === 'ozel' ? '#27ae60' : '#e67e22', marginTop: '10px' }} data-testid="activate-ozel-btn">
              {pricingModeActive === 'ozel' ? '\u2713 OZEL MOD AKTIF' : 'OZEL MOD AKTIF ET'}
            </button>
          </>
        )}

        <button onClick={handleToggleFreeze} style={{ ...styles.freezeButton, backgroundColor: pricesFrozen ? '#e74c3c' : '#27ae60' }} data-testid="freeze-btn">
          {pricesFrozen ? 'Fiyatlari Serbest Birak' : 'Fiyatlari Sabitle'}
        </button>
        <button onClick={handleToggleRounding} style={{ ...styles.freezeButton, backgroundColor: roundingEnabled ? '#3498db' : '#95a5a6' }} data-testid="rounding-btn">
          {roundingEnabled ? 'Yuvarlama: ACIK' : 'Yuvarlama: KAPALI'}
        </button>

        {otherProfiles.length > 0 && (
          <div style={{ marginTop: '20px', padding: '15px', backgroundColor: '#f0f0f0', borderRadius: '10px', border: '2px solid #DA9F54' }}>
            <h3 style={{ textAlign: 'center', marginBottom: '12px', color: '#09301E', fontSize: '15px' }}>Fiyat Kaynagi</h3>
            {priceSource && priceSource !== 'altinkaynak' && (
              <div style={{ textAlign: 'center', marginBottom: '10px', padding: '8px', backgroundColor: '#DA9F54', borderRadius: '8px' }}>
                <span style={{ color: '#000', fontWeight: 'bold', fontSize: '14px' }}>Aktif: {users.find(u => u.profile === priceSource)?.name || priceSource}</span>
              </div>
            )}
            <div style={{ display: 'flex', gap: '8px', justifyContent: 'center', flexWrap: 'wrap' }}>
              {otherProfiles.map(p => (
                <button key={p.profile} onClick={() => setPriceSourceProfile(p.profile)} disabled={priceSource === p.profile}
                  style={{
                    padding: '10px 20px', fontSize: '14px', fontWeight: 'bold', cursor: priceSource === p.profile ? 'default' : 'pointer',
                    backgroundColor: priceSource === p.profile ? '#DA9F54' : '#09301E', color: priceSource === p.profile ? '#000' : '#fff',
                    border: priceSource === p.profile ? '2px solid #b8860b' : '2px solid #09301E', borderRadius: '8px', transition: 'all 0.2s'
                  }}
                  data-testid={`source-${p.profile}-btn`}
                >{p.name}</button>
              ))}
            </div>
            {priceSource && priceSource !== 'altinkaynak' && (
              <button onClick={clearPriceSource}
                style={{ width: '100%', padding: '10px', fontSize: '14px', fontWeight: 'bold', backgroundColor: '#e74c3c', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', marginTop: '10px' }}
                data-testid="clear-source-btn"
              >Iptal Et</button>
            )}
          </div>
        )}

        <button onClick={() => window.location.href = profile === "default" ? "/" : `/${profile}`} style={styles.backButton}>Fiyat Sayfasina Don</button>
      </div>
    </div>
  );
};

export default MarjTab;
